import { render, staticRenderFns } from "./stepButton.vue?vue&type=template&id=bc3c9c20"
import script from "./stepButton.vue?vue&type=script&lang=js"
export * from "./stepButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports